import React from 'react';
import { Container } from 'reactstrap';
import { DashboardPageHeader, ComingSoonCard, DeptToolsGrid, DeptReportsGrid } from '../../Components/Common/DashboardKit';

/**
 * Quality module landing page.
 *
 * Owner (2026-10-05): the department pages list the modules the team uses and the KPI
 * reports that matter to it (DeptLandingSections); each card shows only when the person
 * may open it (the earlier hand-written shortcuts showed to everyone with the page).
 * The route is gated by dept.quality in allRoutes.js.
 */
const TOOLS = [
    "di", "diChangeLog", "mafia", "cr", "dmsAll", "dmsMyApprovals", "dmsRelease", "tasks", "epoCreate",
];
const REPORTS = ["dmr-performance-quality", "rma-kpi-quality", "vendor-performance-kpi"];

const Quality = () => {
    document.title = "SSW Technologies Dashboard";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-shield-check-line"
                        eyebrow="Quality"
                        title="Quality"
                        subtitle="Inspection, non-conformance, and audits"
                        tone="teal"
                        breadcrumb={[
                            { label: "Dashboards", to: "/" },
                            { label: "Quality" },
                        ]}
                    />

                    <DeptToolsGrid
                        ids={TOOLS}
                        title="Quality tools"
                        description="Inspection, specs, contract reviews and documents"
                        icon="ri-microscope-line"
                    />
                    <DeptReportsGrid ids={REPORTS} />

                    <ComingSoonCard
                        compact
                        icon="ri-shield-check-line"
                        title="More for Quality later"
                        message="Ideas for later: non-conformance trends, audit history and CAPA tracking. The cards above are live today."
                        tone="warning"
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Quality;
